import { cn } from 'cn';
import { useTranslation } from 'react-i18next';
import Illustration from '#/assets/error-page-illustration.svg?react';

type ErrorPageProps = {
  status?: number;
};

const supportedStatuses = [204, 403, 404, 500] as const;
type SupportedStatus = (typeof supportedStatuses)[number];

export function ErrorPage({ status }: ErrorPageProps) {
  const { t } = useTranslation();

  const statusMessage =
    status && supportedStatuses.includes(status)
      ? t(`errorPage.body.${status as SupportedStatus}`)
      : null;

  return (
    <section
      className={cn(
        'panel space-y-4 p-6 md:flex md:h-[calc(100vh-10.25rem)] md:items-center md:justify-center md:space-y-0',
        'md:bg-img-error-page bg-white',
      )}
    >
      <Illustration className="h-auto max-w-full md:hidden" />
      <div className="max-w-125 md:relative md:top-2 md:mt-0">
        <h1 className="typ-headline-2xl">{t('errorPage.title')}</h1>
        {
          <p className="typ-body text-neutral-110 mt-8 leading-4">
            {statusMessage}
          </p>
        }
        <h2 className="typ-headline-md mt-8">
          {t('errorPage.contactSupport')}
        </h2>
        <a href="tel:+4533111511" className="typ-link">
          3311 1511
        </a>
      </div>
    </section>
  );
}

export default ErrorPage;
